module.exports = __webpack_public_path__ + "static/CVS-Catch-E-cigarettes-Risks-STEM-V2.1-047444a5bc06436bb856723de3be57c9.pdf";